const countOffers = ({ http, criterias }) => {
  const params = {
    ...criterias
  };

  return http({
    params,
    url: '/count'
  });
};

export default countOffers;
